const FAVORITE_TYPES = {
  FETCH_FAVORITES_BEGIN: "FETCH_FAVORITES_BEGIN",
  FETCH_FAVORITES_SUCCESS: "FETCH_FAVORITES_SUCCESS",
  FETCH_FAVORITES_FAILURE: "FETCH_FAVORITES_FAILURE",

  CHECK_MARKED_BEGIN: "CHECK_MARKED_BEGIN",
  CHECK_MARKED_SUCCESS: "CHECK_MARKED_SUCCESS",
  CHECK_MARKED_FAILURE: "CHECK_MARKED_FAILURE",

  MARK_FAVORITE_BEGIN: "MARK_FAVORITE_BEGIN",
  MARK_FAVORITE_SUCCESS: "MARK_FAVORITE_SUCCESS",
  MARK_FAVORITE_FAILURE: "MARK_FAVORITE_FAILURE",

  REMOVE_FAVORITE_BEGIN: "REMOVE_FAVORITE_BEGIN",
  REMOVE_FAVORITE_SUCCESS: "REMOVE_FAVORITE_SUCCESS",
  REMOVE_FAVORITE_FAILURE: "REMOVE_FAVORITE_FAILURE",
};

export default FAVORITE_TYPES;
